// A one-shot confetti burst on a throwaway canvas: no dependency, no
// residue. The canvas ignores the pointer and removes itself when the
// last piece settles. Skipped entirely under prefers-reduced-motion.
export function burstConfetti(x?: number, y?: number): void {
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

  const canvas = document.createElement("canvas");
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = window.innerWidth * dpr;
  canvas.height = window.innerHeight * dpr;
  canvas.setAttribute("aria-hidden", "true");
  Object.assign(canvas.style, {
    position: "fixed",
    inset: "0",
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: "120",
  });
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.scale(dpr, dpr);
  document.body.appendChild(canvas);

  const acc = getComputedStyle(document.documentElement).getPropertyValue("--acc").trim();
  const palette = [acc || "#3E7A6B", "#C4694D", "#D9A066", "#9AC0B4", "#EFE9DC"];

  const ox = x ?? window.innerWidth / 2;
  const oy = y ?? window.innerHeight * 0.3;
  const parts = Array.from({ length: 140 }, () => {
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.2;
    const speed = 6 + Math.random() * 9;
    return {
      x: ox,
      y: oy,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      w: 5 + Math.random() * 5,
      h: 8 + Math.random() * 6,
      rot: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 0.3,
      wobble: Math.random() * Math.PI * 2,
      color: palette[Math.floor(Math.random() * palette.length)] ?? palette[0] ?? "#3E7A6B",
    };
  });

  const started = performance.now();
  const DURATION = 1700;
  const tick = (now: number) => {
    const t = now - started;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    const fade = Math.max(0, 1 - t / DURATION);
    for (const p of parts) {
      p.vy += 0.22;
      p.vx *= 0.99;
      p.vy *= 0.995;
      p.wobble += 0.08;
      p.x += p.vx + Math.sin(p.wobble) * 0.6;
      p.y += p.vy;
      p.rot += p.vr;
      ctx.save();
      ctx.globalAlpha = fade;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * (0.6 + 0.4 * Math.abs(Math.sin(p.wobble))));
      ctx.restore();
    }
    if (t < DURATION) requestAnimationFrame(tick);
    else canvas.remove();
  };
  requestAnimationFrame(tick);
}
